module.exports = __webpack_public_path__ + "static/media/tutorial-start-step3.f4d0bb53.png";